import React, { useEffect, useRef, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { SaleOrderList } from '../TitleList';
import styled, { inputImages, inputStyles, inputNumber, inputNumbers } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { useNavigate } from 'react-router-dom';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { selectCloths, selectFirm, selectItemAvg, selectItems, selectJobRate, selectLogo, selectParty, selectPriPerGrp, selectSalebarcd, selectSchool, selectsono, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchPricePerData } from '../../Store/PHPSlice/Sale/PricePercent';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { useNavigation } from '../NavigationContext';
import { fetchLogoData } from '../../Store/PHPSlice/Logo';
import { fetchTransportData } from '../../Store/PHPSlice/Transport';
import { fetchSaleBarcode, fetchSOno, insertSOquotwise } from '../../Store/PHPSlice/Sale/SaleOrder';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import { fetchJobRateData } from '../../Store/PHPSlice/JobRate';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const DirectSO = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        ordt: getCurrentDate(),
        sono: '',
        item: ' ',
        firm: ' ',
        party: ' ',
        schl: ' ',
        totqty: '0',
        mcloth: ' ',
        m1cloth: ' ',
        m2cloth: ' ',
        m3cloth: ' ',
        entry_type: '1',
        quotId: '0',
        qty: [],
        rate: [],
        barcode: '',
        orgbarcode: '',
        orderNo: '',
        userId: userdata?.ID
    });

    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        item: fetchItemData,
        party: fetchPartyData,
        schl: fetchSchoolData
        // Add more mappings if needed
    };
    const [errors, setErrors] = useState({});
    const [openTable, setOpenTable] = useState(false);
    const [entries, setEntries] = useState([]);
    const [clothdata, setClothdata] = useState([]);
    const [m1clothdata, setM1Clothdata] = useState([]);
    const [m2clothdata, setM2Clothdata] = useState([]);
    const [m3clothdata, setM3Clothdata] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [qtyIndex, setQtyIndex] = useState([]);
    const [itemData, setItemData] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const itemlist = useSelector(selectItems);
    const schlList = useSelector(selectSchool);
    const pricelist = useSelector(selectPriPerGrp);
    const clothlist = useSelector(selectCloths);
    const sono = useSelector(selectsono);
    const barcode = useSelector(selectSalebarcd);
    const itemAvglist = useSelector(selectItemAvg);
    const jobratelist = useSelector(selectJobRate);

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchItemData());
        dispatch(fetchSchoolData());
        dispatch(fetchPricePerData());
        dispatch(fetchClothData());
        dispatch(fetchLogoData());
        dispatch(fetchTransportData());
        dispatch(fetchSOno());
        dispatch(fetchSaleBarcode());
        dispatch(fetchItemAvgData());
        dispatch(fetchJobRateData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);


    useEffect(() => {
        if (sono) {
            const item = sono.data.SOno || '';
            setFormData(prevFormData => ({
                ...prevFormData,
                sono: `D-${item}`
            }));
        }
    }, [sono]);

    useEffect(() => {
        if (barcode?.data) {
            const bar = barcode?.data?.sobar;
            setFormData(prevFormData => ({
                ...prevFormData,
                barcode: prevFormData.barcode || bar,
                orgbarcode: bar
            }));
        }
    }, [barcode]);

    // console.log(itemData);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        // Update form data with the selected dropdown value
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        switch (dropdownType) {
            case 'item':
                if (value) {
                    // Filter and process average values
                    const selectPanna = itemAvglist.data.filter(val => val.itemId === value);
                    const selectAvg = selectPanna.filter(val => val.avg !== '0');
                    const selectm1Avg = selectPanna.filter(val => val.avg1 !== '0');
                    const selectm2Avg = selectPanna.filter(val => val.avg2 !== '0');
                    const selectm3Avg = selectPanna.filter(val => val.avg3 !== '0');

                    // Determine unique sizes
                    const uniquePannasizes = [...new Set(selectAvg.map(val => val.panna_size))];
                    const uniqueM1Pannasizes = [...new Set(selectm1Avg.map(val => val.panna_size))];
                    const uniqueM2Pannasizes = [...new Set(selectm2Avg.map(val => val.panna_size))];
                    const uniqueM3Pannasizes = [...new Set(selectm3Avg.map(val => val.panna_size))];

                    // Filter cloth data based on sizes
                    const filterCloth = clothlist.data.filter(val => uniquePannasizes.includes(val.panna_size));
                    const filterM1Cloth = clothlist.data.filter(val => uniqueM1Pannasizes.includes(val.panna_size));
                    const filterM2Cloth = clothlist.data.filter(val => uniqueM2Pannasizes.includes(val.panna_size));
                    const filterM3Cloth = clothlist.data.filter(val => uniqueM3Pannasizes.includes(val.panna_size));

                    // Update cloth data
                    setClothdata(filterCloth);
                    setM1Clothdata(filterM1Cloth);
                    setM2Clothdata(filterM2Cloth);
                    setM3Clothdata(filterM3Cloth);

                    // Update matching options
                    const newMatching = [];
                    if (filterM1Cloth.length > 0) newMatching.push({ label: 'Matching 1', value: '1' });
                    if (filterM2Cloth.length > 0) newMatching.push({ label: 'Matching 2', value: '2' });
                    if (filterM3Cloth.length > 0) newMatching.push({ label: 'Matching 3', value: '3' });

                }
                break;
            default:
                break;
        }
    };

    const fetchClothBalmtr = async (id) => {
        try {
            const endpoint = `getBalMtrFromClothStkforSaleorder&clothId=${id}`;
            const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
            return response?.data?.data;

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    // async function getItemClothData(formData) {
    //     const { item, mcloth, m1cloth, m2cloth, m3cloth } = formData;
    //     const clothTypes = [
    //         { key: 'mcloth', id: mcloth, avgKey: 'mavg', avgs: 'avg', clothKey: 'mclothNm', idKey: 'mId', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr' },
    //         { key: 'm1cloth', id: m1cloth, avgKey: 'm1avg', avgs: 'avg1', clothKey: 'm1cloth', idKey: 'm1Id', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr1' },
    //         { key: 'm2cloth', id: m2cloth, avgKey: 'm2avg', avgs: 'avg2', clothKey: 'm2cloth', idKey: 'm2Id', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr2' },
    //         { key: 'm3cloth', id: m3cloth, avgKey: 'm3avg', avgs: 'avg3', clothKey: 'm3cloth', idKey: 'm3Id', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr3' }
    //     ];

    //     // Initialize a local data object
    //     const itemData = {};

    //     // Update item details
    //     const selectedItem = itemlist?.data?.find(itemData => itemData.ID === item);
    //     if (selectedItem) {
    //         const arr_size = selectedItem.size.split(',');
    //         itemData.itemId = item;
    //         itemData.itemNm = selectedItem.itemNm;
    //         itemData.size = arr_size;
    //         itemData.rate = Array(arr_size?.length).fill(0);
    //         itemData.qty = Array(arr_size?.length).fill(0);
    //     }

    //     // Update cloth details and averages
    //     clothTypes.forEach(({ id, avgKey, clothKey, idKey, avgs, stkmtr }) => {
    //         if (id) {
    //             const selectedCloth = clothlist?.data2?.find(cloth => cloth.ID === id);
    //             if (selectedCloth) {
    //                 // await the API call
    //                 const stkmtr2 = await fetchClothBalmtr(selectedCloth?.ID);
    //                 console.log("Fetched mtr:", stkmtr2);
    //                 const avgData = itemAvglist?.data
    //                     .filter(avg => avg.itemId === item && avg.panna_size === selectedCloth.panna_size)
    //                     .map(avg => avg[avgs]);

    //                 itemData[avgKey] = avgData;
    //                 itemData[clothKey] = selectedCloth.clothNm;
    //                 itemData[idKey] = selectedCloth.ID;
    //                 itemData[stkmtr] = stkmtr2?.mtr;
    //             }
    //         }
    //     });

    //     return itemData;
    // }

    async function getItemClothData(formData) {
        const { item, mcloth, m1cloth, m2cloth, m3cloth } = formData;
        const clothTypes = [
            { key: 'mcloth', id: mcloth, avgKey: 'mavg', avgs: 'avg', clothKey: 'mclothNm', idKey: 'mId', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr' },
            { key: 'm1cloth', id: m1cloth, avgKey: 'm1avg', avgs: 'avg1', clothKey: 'm1cloth', idKey: 'm1Id', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr1' },
            { key: 'm2cloth', id: m2cloth, avgKey: 'm2avg', avgs: 'avg2', clothKey: 'm2cloth', idKey: 'm2Id', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr2' },
            { key: 'm3cloth', id: m3cloth, avgKey: 'm3avg', avgs: 'avg3', clothKey: 'm3cloth', idKey: 'm3Id', rate: 'rate', qty: 'qty', stkmtr: 'stkmtr3' }
        ];

        // Initialize a local data object
        const itemData = {};

        // Update item details
        const selectedItem = itemlist?.data?.find(itemData => itemData.ID === item);
        if (selectedItem) {
            const arr_size = selectedItem.size.split(',');
            itemData.itemId = item;
            itemData.itemNm = selectedItem.itemNm;
            itemData.size = arr_size;
            itemData.rate = Array(arr_size?.length).fill(0);
            itemData.qty = Array(arr_size?.length).fill(0);
        }

        // Update cloth details and averages
        for (const { id, avgKey, clothKey, idKey, avgs, stkmtr } of clothTypes) {
            if (id) {
                const selectedCloth = clothlist?.data2?.find(cloth => cloth.ID === id);
                if (selectedCloth) {
                    try {
                        // await the API call
                        const stkmtr2 = await fetchClothBalmtr(selectedCloth?.ID);
                        // console.log("Fetched mtr:", stkmtr2);

                        const avgData = itemAvglist?.data
                            .filter(avg => avg.itemId === item && avg.panna_size === selectedCloth.panna_size)
                            .map(avg => avg[avgs]);

                        itemData[avgKey] = avgData;
                        itemData[clothKey] = selectedCloth.clothNm;
                        itemData[idKey] = selectedCloth.ID;
                        itemData[stkmtr] = stkmtr2?.mtr;
                    } catch (err) {
                        console.error("Error fetching cloth data:", err);
                    }
                }
            }
        }

        return itemData;
    }


    function convertIntoOneObject(itemData, formData) {
        if (formData.qty.length > 0 && formData.rate.length > 0 && itemData) {

            // const totarr = qtyIndex?.map(item => formData.qty[item]);
            const totarr = itemData?.qty?.filter((item) => item !== 0);
            const sumqty = totarr?.reduce((sum, qty) => sum + parseInt(qty) || 0, 0);
            const filteredSizes = itemData?.size?.filter((_, index) => {
                const qty = itemData?.qty?.[index];
                return qty !== 0 && qty !== '' && qty !== null && qty !== undefined;
            });

            const filteredRates = itemData?.rate?.filter((_, index) => {
                const qty = itemData?.qty?.[index];
                return qty !== 0 && qty !== '' && qty !== null && qty !== undefined;
            });

            var tableData = {
                particulars: `${formData.barcode} - ${itemData.itemNm} 
                ${itemData.mclothNm}
                ${itemData.m1cloth ? itemData.m1cloth : ''}
                ${itemData.m2cloth ? itemData.m2cloth : ''} 
                ${itemData.m3cloth ? itemData.m3cloth : ''}`,
                // size: qtyIndex?.map(item => itemData.size[item]) || [],
                size: filteredSizes || [],
                rate: filteredRates || [],
                qty: totarr || [],
                totqty: sumqty || '',
                itemId: itemData.itemId,
                quotId: formData.quotId,
                schoolId: formData.schl,
                clothId: itemData.mId || '0',
                mclothNm: itemData.mclothNm,
                mavg: itemData.mavg || [],
                m1Id: itemData.m1Id || '0',
                m1cloth: itemData.m1cloth || '',
                m1avg: itemData.m1avg || [],
                m2Id: itemData.m2Id || '0',
                m2cloth: itemData.m2cloth || '',
                m2avg: itemData.m2avg || [],
                m3Id: itemData.m3Id || '0',
                m3cloth: itemData.m3cloth || '',
                m3avg: itemData.m3avg || [],
                barcode: formData.barcode || '',
                // orderNo:formData.orderNo||'',
                itemNm: itemData.itemNm || '',
                stkmtr: itemData?.stkmtr,
                stkmtr1: itemData?.stkmtr1,
                stkmtr2: itemData?.stkmtr2,
                stkmtr3: itemData?.stkmtr3
            };

        } else {
            alert('Enter the Rate and Qty Values');
        }
        return tableData;
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const handleQtyChange = (index, value, type) => {
        // Convert value to a number and validate
        const numericValue = value ? Number(value) : '';

        // Check if the converted value is a valid number or empty
        if (isNaN(numericValue) && value !== '') {
            // Optionally, you can display an error message or handle invalid input
            console.error(`Please enter a valid number for ${type}`);
            return; // Exit the function if invalid
        }

        if (type === 'qty' && value !== '') {
            setQtyIndex(prev => {
                // Add the index only if it is not already present
                if (!prev.includes(index)) {
                    return [...prev, index];
                }
                return prev;
            });
        }
        const updatedItemData = { ...itemData };
        // Update either 'rate' or 'qty' based on the field
        if (type === 'rate') {
            updatedItemData.rate[index] = numericValue;
        } else if (type === 'qty') {
            updatedItemData.qty[index] = numericValue;
        }

        // Set the updated state
        setItemData(updatedItemData);

        setFormData(prevFormData => {
            const newData = { ...prevFormData };
            if (type === 'qty') {
                const newQty = [...prevFormData.qty];
                newQty[index] = numericValue; // Set the validated quantity value
                newData.qty = newQty;
            } else if (type === 'rate') {
                const newRate = [...prevFormData.rate];
                newRate[index] = numericValue; // Set the validated rate value
                newData.rate = newRate;
            }

            return newData;
        });
    };



    const handleAddClick = async () => {
        if (formData.item.trim() !== "" && formData.mcloth.trim() !== "") {
            const data = await getItemClothData(formData);
            console.log(data)
            setItemData(data);
            setOpenTable(true);
        } else {
            if (formData.item.trim() === "") {
                alert("Select Item");
            } else if (formData.mcloth.trim() === "") {
                alert("Select Main Cloth");
            }
        }
    }
    // console.log(itemData);

    const handleAddItemsClick = () => {

        const addItems = convertIntoOneObject(itemData, formData);
        // console.log(addItems);
        setEntries(prevEntries => [...prevEntries, addItems]);
        const newTotqty = entries.reduce((sum, item) => sum + item.totqty, 0) + addItems.totqty;
        const nextBar = parseFloat(formData.barcode) + 1;
        // console.log(nextBar);
        setFormData(prev => ({
            ...prev,
            barcode: nextBar,
            item: '',
            mcloth: '',
            m1cloth: '',
            m2cloth: '',
            m3cloth: '',
            rate: [],
            qty: [],
            totqty: newTotqty,
        }));
        // console.log(formData);
        setOpenTable(false);
    };

    const handleRemoveClick = () => {
        setEntries(prevEntries => {
            // Step 1: Filter entries to keep (i.e., not selected)
            const remainingEntries = prevEntries.filter((_, index) => !selectedRows.has(index));

            // Step 2: Update formData.totqty
            const selectedData = prevEntries.filter((_, index) => selectedRows.has(index));
            const totalQtyToRemove = selectedData.reduce((acc, item) => acc + parseInt(item.totqty, 10), 0);


            // Step 3: Reassign barcodes from a base value
            const baseBarcode = parseInt(formData.orgbarcode, 10); // You can change this to match your logic
            const updatedEntries = remainingEntries.map((item, i) => ({
                ...item,
                barcode: `${baseBarcode + i}`, // e.g., '10001', '10002', etc.
                particulars: `${baseBarcode + i} - ${item.itemNm} ${item.mclothNm} ${item.m1cloth ? item.m1cloth : ''} ${item.m2cloth ? item.m2cloth : ''} ${item.m3cloth ? item.m3cloth : ''}`,
            }));

            // Set the last barcode value
            const latestBar = updatedEntries.length > 0 ? `${baseBarcode + updatedEntries.length}` : formData.orgbarcode;

            setFormData(prevFormData => ({
                ...prevFormData,
                totqty: parseInt(prevFormData.totqty, 10) - totalQtyToRemove || '0',
                barcode: latestBar
            }));

            return updatedEntries;
        });
        setSelectedRows(new Set()); // Clear the selected rows
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    function finalObject(entries, formData) {
        const final = {
            firm: formData.firm,
            entry_type: formData.entry_type,
            ordt: formData.ordt,
            sono: formData.sono,
            orderNo: formData.orderNo,
            party: formData.party,
            totqty: formData.totqty,
            entries: entries,
            userId: formData.userId
        }
        return final;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const finalobj = finalObject(entries, formData);
            // console.log(finalobj);
            const result = await dispatch(insertSOquotwise(finalobj)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Sale Order Added");
            alert('Sale Order Added');
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };


    const handleNavigateItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleNavigateSchool = () => {
        window.open(`/NewSchoolEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateItemAvg = () => {
        window.open(`/new-item-avg-entry`, '_blank', 'width=1000,height=1000,scrollbars=yes,resizable=yes');
    };

    // console.log(itemData);

    const dropdownlistfirst = [
        {
            label: 'Item',
            id: 'item',
            options: itemlist?.data || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateItem(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('item'),
            handleDropdownClose: () => handleDropdownClose('item'),
        },
        {
            label: 'School',
            id: 'schl',
            options: schlList?.data || [],
            value: formData.schl,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schl', value: newValue ? newValue.ID : '' } }, 'schl'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateSchool(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('schl'),
            handleDropdownClose: () => handleDropdownClose('schl'),
        }

    ];

    const dropdownlistsecond = [
        {
            label: 'Party',
            id: 'party',
            options: partylist?.data2 || [],
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('party'),
            handleDropdownClose: () => handleDropdownClose('party'),
        }
    ];


    return (
        <>
            <Titlebar data={SaleOrderList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Direct - Sale Order Entry</h2>
                <Grid container>
                    <Grid item>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="firm"
                                                    options={firmlist.data}
                                                    getOptionLabel={(option) => option.firmNm || ''} // Ensure this returns the correct label
                                                    value={firmlist.data.find(firm => firm.ID === formData.firm) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="item">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="item"
                                                    options={itemlist.data}
                                                    getOptionLabel={(option) => option.itemNm || ''} // Ensure this returns the correct label
                                                    value={itemlist.data.find(item => item.ID === formData.item) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="schl">School:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="schl"
                                                    options={schlList.data}
                                                    getOptionLabel={(option) => option.schoolNm || ''} // Ensure this returns the correct label
                                                    value={schlList.data.find(schl => schl.ID === formData.schl) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'schl', value: newValue ? newValue.ID : '' } }, 'schl')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}


                                {
                                    dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mcloth">Main Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                {/* <Autocomplete
                                                    id="mcloth"
                                                    options={clothdata}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || ''} // Ensure this returns the correct label
                                                    value={clothdata.find(mcloth => mcloth.ID === formData.mcloth) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'mcloth', value: newValue ? newValue.ID : '' } }, 'mcloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                /> */}
                                                <Autocomplete
                                                    id="mcloth"
                                                    name="mcloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={clothlist?.data?.find(item => item.ID === formData.mcloth) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'mcloth', value: newValue ? newValue.ID : '' } }, 'mcloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.mcloth}
                                                            helperText={errors.mcloth}
                                                        />
                                                    )}
                                                />

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="party">Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="party"
                                                    options={partylist?.data2}
                                                    getOptionLabel={(option) => option.partyNm || ''} // Ensure this returns the correct label
                                                    value={partylist?.data2?.find(party => party.ID === formData.party) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                <Grid item xs={12} md={6}>
                                    {/* {m1clothdata.length > 0 && */}
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="m1cloth">Matching 1 Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="m1cloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || ''} // Ensure this returns the correct label
                                                    value={clothlist?.data?.find(item => item.ID === formData.m1cloth) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'm1cloth', value: newValue ? newValue.ID : '' } }, 'm1cloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    {/* } */}
                                </Grid>

                                {[
                                    { label: 'Order Date', name: 'ordt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    {/* {m2clothdata.length > 0 && */}
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="m2cloth">Matching 2 Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="m2cloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || ''} // Ensure this returns the correct label
                                                    value={clothlist?.data?.find(item => item.ID === formData.m2cloth) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'm2cloth', value: newValue ? newValue.ID : '' } }, 'm2cloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    {/* } */}
                                </Grid>

                                {[
                                    { label: 'SO No', name: 'sono', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    {/* {m3clothdata.length > 0 && */}
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="m3cloth">Matching 3 Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="m3cloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || ''} // Ensure this returns the correct label
                                                    value={clothlist?.data?.find(item => item.ID === formData.m3cloth) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'm3cloth', value: newValue ? newValue.ID : '' } }, 'm3cloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    {/* } */}
                                </Grid>


                                {[
                                    { label: 'Barcode', name: 'barcode', type: 'readOnly' },
                                    { label: 'Order No', name: 'orderNo' },
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6} style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <Button variant="contained" color="primary" onClick={handleAddClick}>add</Button>

                                    <Button variant="contained" color="primary" onClick={handleNavigateItemAvg}>Add Item Avg.</Button>
                                </Grid>

                                {
                                    openTable === true ? (
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow className='tbl-row'>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Particulars</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                                {itemData.size ? itemData.size.map((item, index) => (
                                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                                                )) : ''}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                {itemData.itemNm &&
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        {`Item :${itemData.itemNm}`}<br />
                                                                        {itemData.mId ?
                                                                            (
                                                                                <>
                                                                                    {/* {`Main Cloth :${itemData.mclothNm} - stock ${itemData.stkmtr}`} <br />
                                                                                    {itemData.m1Id ? `M1 : ${itemData.m1cloth} - stock ${itemData.stkmtr1}` : ''} <br />
                                                                                    {itemData.m2Id ? `M2 : ${itemData.m2cloth} - stock ${itemData.stkmtr2}` : ''} <br />
                                                                                    {itemData.m3Id ? `M3 : ${itemData.m3cloth} - stock ${itemData.stkmtr3}` : ''} */}

                                                                                    {`Main Cloth : ${itemData.mclothNm} `}
                                                                                    <span
                                                                                        style={{
                                                                                            color: itemData.stkmtr > 0 ? "green" : "red",
                                                                                            fontWeight: "bold"
                                                                                        }}
                                                                                    >
                                                                                        (stock : {itemData.stkmtr})
                                                                                    </span>
                                                                                    <br />

                                                                                    {itemData.m1Id ? (
                                                                                        <>
                                                                                            {`M1 : ${itemData.m1cloth} `}
                                                                                            <span
                                                                                                style={{
                                                                                                    color: itemData.stkmtr1 > 0 ? "green" : "red",
                                                                                                    fontWeight: "bold"
                                                                                                }}
                                                                                            >
                                                                                                (stock : {itemData.stkmtr1})
                                                                                            </span>
                                                                                            <br />
                                                                                        </>
                                                                                    ) : ''}

                                                                                    {itemData.m2Id ? (
                                                                                        <>
                                                                                            {`M2 : ${itemData.m2cloth} `}
                                                                                            <span
                                                                                                style={{
                                                                                                    color: itemData.stkmtr2 > 0 ? "green" : "red",
                                                                                                    fontWeight: "bold"
                                                                                                }}
                                                                                            >
                                                                                                (stock : {itemData.stkmtr2})
                                                                                            </span>
                                                                                            <br />
                                                                                        </>
                                                                                    ) : ''}

                                                                                    {itemData.m3Id ? (
                                                                                        <>
                                                                                            {`M3 : ${itemData.m3cloth} `}
                                                                                            <span
                                                                                                style={{
                                                                                                    color: itemData.stkmtr3 > 0 ? "green" : "red",
                                                                                                    fontWeight: "bold"
                                                                                                }}
                                                                                            >
                                                                                                (stock : {itemData.stkmtr3})
                                                                                            </span>
                                                                                        </>
                                                                                    ) : ''}

                                                                                </>

                                                                            ) : ''
                                                                        }
                                                                    </TableCell>
                                                                }


                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    Rate <hr />
                                                                    Qty
                                                                </TableCell>

                                                                {itemData.size ? itemData.size.map((item, index) => (
                                                                    <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }} key={index}>
                                                                        <input
                                                                            type="text"
                                                                            name='rate'
                                                                            min={0}
                                                                            value={itemData.rate[index] || 0}
                                                                            onChange={(e) => handleQtyChange(index, e.target.value, 'rate')}
                                                                            style={{ width: '50px', padding: '1px', marginBottom: '10px' }}
                                                                        />
                                                                        <hr />
                                                                        <input
                                                                            type="text"
                                                                            name='qty'
                                                                            min={0}
                                                                            value={itemData.qty[index] || 0}
                                                                            onChange={(e) => handleQtyChange(index, e.target.value, 'qty')}
                                                                            style={{ width: '50px', padding: '1px', marginTop: '10px' }}
                                                                        />
                                                                    </TableCell>
                                                                )) : null}
                                                            </TableRow>

                                                            {/* <TableRow>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>
                                                                {itemData.size ? itemData.size.map((item, index) => (
                                                                    <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }} key={index}>
                                                                        <input
                                                                            type="text"
                                                                            name='qty'
                                                                            value={formData.qty[index] || '0'}
                                                                            onChange={(e) => handleQtyChange(index, e.target.value, 'qty')}
                                                                            style={{ width: '50px', padding: '1px' }}
                                                                        />
                                                                    </TableCell>
                                                                )) : ''}
                                                            </TableRow> */}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Button variant="contained" color="primary" onClick={handleAddItemsClick} disabled={formData?.qty === 0}>Add Items</Button>
                                            </Grid>
                                        </>
                                    ) : null
                                }
                                <Grid item xs={12} md={12} m={2}>
                                    <Button variant="contained" color="primary" onClick={handleRemoveClick}>Remove</Button>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Remove</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Particular</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate(Rs.)</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Quantity</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Total Qty</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {entries?.length > 0 ? entries?.map((val, index) => (
                                                <TableBody>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                        <Checkbox
                                                            checked={selectedRows.has(index)}
                                                            onChange={() => handleCheckboxChange(index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.particulars}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.size.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.rate.join(',') || 0}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.qty.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.totqty}</TableCell>
                                                </TableBody>
                                            )) : ''}

                                        </Table>
                                    </TableContainer>
                                </Grid>

                                {entries?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default DirectSO;
